'use client';

import { c as _c } from "react/compiler-runtime";
import ChevronLeftIcon from '@heroicons/react/20/solid/ChevronLeftIcon';
import ChevronRightIcon from '@heroicons/react/20/solid/ChevronRightIcon';
import type { KeenSliderInstance } from 'keen-slider';
import 'keen-slider/keen-slider.min.css';
import { useKeenSlider } from 'keen-slider/react';
import { usePathname } from 'next/navigation';
import { useState } from 'react';
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink';
import { getPathLocale } from '@src/i18n/locale.util';
import { useTrackSelectNavCta } from '@src/utils/analytics.util';
import { cn } from '@src/utils/tailwind';
import { Pill } from './Pill';
export interface PillsNavProps {
  items: Array<{
    label: any;
    href: string;
    isVisible: boolean;
  }>;
  builderBlock?: any;
}
export function PillsNav(t0) {
  const $ = _c(33);
  const {
    items: t1
  } = t0;
  const items = t1 === undefined ? [] : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      prev: false,
      next: false
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [isControlVisible, setIsControlVisible] = useState(t2);
  const trackSelectNavCta = useTrackSelectNavCta();
  const pathname = usePathname();
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      perView: "auto",
      spacing: 8
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const [ref, slider] = useKeenSlider({
    mode: "free",
    rubberband: false,
    slides: t3,
    created: syncSlider,
    updated: syncSlider,
    detailsChanged: syncSlider
  });
  function syncSlider(slider_0) {
    const {
      position,
      min,
      max,
      length
    } = slider_0.track.details;
    const isOverflowing = length > 0;
    setIsControlVisible({
      prev: isOverflowing && position > min,
      next: isOverflowing && position < max
    });
  }
  const t4 = "relative -mx-4 lg:mx-0";
  const t5 = isControlVisible.prev && isControlVisible.next;
  const t6 = isControlVisible.prev && !isControlVisible.next;
  const t7 = !isControlVisible.prev && isControlVisible.next;
  let t8;
  if ($[2] !== t5 || $[3] !== t6 || $[4] !== t7) {
    t8 = cn("keen-slider flex", {
      "lg:mask-[linear-gradient(90deg,rgba(255,255,255,0)_0%,rgba(0,0,0,1)_10%,rgba(0,0,0,1)_50%,rgba(0,0,0,1)_90%,rgba(255,255,255,0)_100%)]": t5,
      "lg:mask-[linear-gradient(90deg,rgba(255,255,255,0)_0%,rgba(0,0,0,1)_10%,rgba(0,0,0,1)_50%)]": t6,
      "lg:mask-[linear-gradient(90deg,rgba(0,0,0,1)_90%,rgba(255,255,255,0)_100%)]": t7
    });
    $[2] = t5;
    $[3] = t6;
    $[4] = t7;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t9;
  if ($[6] !== pathname || $[7] !== trackSelectNavCta) {
    t9 = (item, index) => <div key={index} className="keen-slider__slide w-auto! shrink-0 first-of-type:max-lg:pl-4 last-of-type:max-lg:pr-4"><LocalizedLink href={item.href} onClick={() => trackSelectNavCta({
        "cta url": item.href
      })}><Pill key={index} label={item.label} isActive={pathname === `${getPathLocale(pathname)}${item.href}`} /></LocalizedLink></div>;
    $[6] = pathname;
    $[7] = trackSelectNavCta;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const t10 = items.filter(_temp).map(t9);
  let t11;
  if ($[9] !== ref || $[10] !== t10 || $[11] !== t8) {
    t11 = <nav ref={ref} className={t8}>{t10}</nav>;
    $[9] = ref;
    $[10] = t10;
    $[11] = t8;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== slider.current) {
    t12 = () => {
      if (!slider.current) {
        return;
      }
      const {
        moveToIdx,
        track
      } = slider.current;
      const currentIndex = track.details.slides.findIndex(_temp2) ?? 0;
      const prevIndex = Math.max(track.details.minIdx, currentIndex - 4);
      moveToIdx(prevIndex);
    };
    $[13] = slider.current;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== isControlVisible.prev) {
    t13 = cn("absolute top-0 -left-8 hidden h-full pr-10", {
      "lg:block": isControlVisible.prev
    });
    $[15] = isControlVisible.prev;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <ChevronLeftIcon className="size-7" />;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== t12 || $[19] !== t13) {
    t15 = <button onClick={t12} className={t13}>{t14}</button>;
    $[18] = t12;
    $[19] = t13;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== slider.current) {
    t16 = () => {
      if (!slider.current) {
        return;
      }
      const {
        moveToIdx: moveToIdx_0,
        track: track_0
      } = slider.current;
      const currentIndex_0 = track_0.details.slides.findIndex(_temp3) ?? 0;
      const nextIdx = Math.min(track_0.details.maxIdx, currentIndex_0 + 3);
      moveToIdx_0(nextIdx);
    };
    $[21] = slider.current;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== isControlVisible.next) {
    t17 = cn("absolute top-0 -right-8 hidden h-full pl-10", {
      "lg:block": isControlVisible.next
    });
    $[23] = isControlVisible.next;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <ChevronRightIcon className="size-7" />;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  let t19;
  if ($[26] !== t16 || $[27] !== t17) {
    t19 = <button onClick={t16} className={t17}>{t18}</button>;
    $[26] = t16;
    $[27] = t17;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] !== t11 || $[30] !== t15 || $[31] !== t19) {
    t20 = <div className={t4}>{t11}{t15}{t19}</div>;
    $[29] = t11;
    $[30] = t15;
    $[31] = t19;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  return t20;
}
function _temp3(slide_0) {
  return slide_0.portion >= 1;
}
function _temp2(slide) {
  return slide.portion >= 1;
}
function _temp(i) {
  return !!i.isVisible;
}